module.exports = __webpack_public_path__ + "static/media/fte-sleep-thumbnail.29061625.png";